import * as XLSX from "xlsx";

const SHEET_NAME = "Inward";
const FILENAME = "inward_upload_format.xlsx";
const TEMPLATE_HEADERS = [
 "Invoice Number",
 "Invoice Date",
 "Company",
 "Customer SKU Code",
 // "Product Description",      // optional (removed from template)
 "Product Temperature",
 "Invoice Quantity",
 "Received Quantity",
 "Dock Number",
 "Dock In Time",
 "Dock Out Time",
 "Vehicle Number",
 "Vehicle Temperature",
 "Vehicle Reporting Date",
 "Vehicle Reporting Time",
 "Location",
 // "UOM",
 // // NEW: Outer UOM Quantity (used only when UOM is provided)
 // "Outer UOM Quantity",
 // "Storage Type",
 "Batch Number",
 "Manufacturing Date",
 // OLD: Expiry provided in upload; now derived from Product Master shelfLifeDays
 // "Expiry Date",
 "Batch Quantity",
 // "Condition",
 // "Bin Code",
];
const INSTRUCTIONS_ROW = [
 "e.g. INV-001 (required, same invoice = multiple products)",
 "YYYY-MM-DD (required)",
 "Company name(s), comma separated for multiple (optional)",
 "Customer SKU Code(s), comma separated for multiple (required)",
 // "Product description (optional) - keep same order as SKU list",
 "number (optional) e.g. 4 or 4.5",
 "number > 0 (required)",
 "number >= 0 (required)",
 "optional (e.g. D-01)",
 "YYYY-MM-DD HH:mm (optional) or Excel datetime",
 "YYYY-MM-DD HH:mm (optional) or Excel datetime",
 "optional",
 "number (optional) e.g. 2 or 2.5",
 "YYYY-MM-DD (optional)",
 "time e.g. 09:30 or 14:00 (optional)",
 "optional (e.g. Warehouse A)",
 // "PCS, KG, L, BOX, PACK, CASE, or UNIT (optional)",
 // "Outer UOM quantity (optional, numeric > 0, used only when UOM is filled)",
 // "Frozen, Chilled, Ambient, or Tropical (optional)",
 // "Required if Storage Type is selected (e.g. CH-01)",
 "Batch number for these batches (optional, kept as-is in system)",
 "Manufacturing date(s),Can not be future,(required)",
 // OLD: Expiry entered by user; now derived from Product Master shelfLifeDays
 // "Expiry date(s), comma separated for multiple batches (required)",
 "Batch quantity(s), (required)",
 // "Condition(s), comma separated for multiple batches (GOOD/DAMAGED/EXPIRED)",
 // "Bin code(s), comma separated for multiple batches (required)",
];

// const SAMPLE_ROW_1 = [
//  "INV-001",
//  "2025-02-01",
//  "Company A, Company B",
//  "SKU-001, SKU-002",
//  "Desc for SKU-001, Desc for SKU-002", // ✅ NEW
//  4,
//  100,
//  100,
//  "D-01",
//  "2025-02-01 10:00",
//  "2025-02-01 11:30",
//  "VEH-001",
//  2,
//  "Warehouse A",
//  "BOX",
//  "Frozen",
//  // "CH-01",
//  "BATCH-INV001-01",
//  "2025-01-01, 2025-01-15",
//  // OLD: sample expiry values; expiry now derived from shelfLifeDays
//  // "2026-01-01, 2026-01-15",
//  "50, 50",
//  // "GOOD",
//  // "A-01-01, A-01-02",
// ];
const SAMPLE_ROW_1 = [
 "INV-001",
 "2026-04-01",
 "Company A, Company B",
 "SKU-001",
 // "Desc for SKU-001, Desc for SKU-002",
 4,
 100,
 100,
 "D-01",
 "2026-02-01 10:00",
 "2026-02-01 11:30",
 "VEH-001",
 2,
 "2026-04-01",
 "09:30",
 "Warehouse A",
 // "BOX",
 // 10, // Outer UOM Quantity
 "BATCH-INV001-01",
 "2025-01-01",
 "100",
];

const SAMPLE_ROW_2 = [
 "INV-002",
 "2026-04-02",
 "Company C",
 "SKU-003",
 // "Desc for SKU-003",
 5,
 80,
 60,
 "D-02",
 "2026-02-02 09:10",
 "2026-02-02 10:00",
 "VEH-002",
 3,
 "2026-04-02",
 "14:00",
 "Warehouse B",
 // "PCS",
 // "", // Outer UOM Quantity (blank because PCS / not needed)
 "BATCH-INV002-01",
 "2025-01-02",
 "60",
];
// const SAMPLE_ROW_2 = [
//  "INV-002",
//  "2025-02-02",
//  "Company C",
//  "SKU-003",
//  "Desc for SKU-003", // ✅ NEW
//  5,
//  80,
//  60,
//  "D-02",
//  "2025-02-02 09:10",
//  "2025-02-02 10:00",
//  "VEH-002",
//  3,
//  "Warehouse B",
//  "PCS",
//  "Chilled",
//  // "CH-02",
//  "BATCH-INV002-01",
//  "2025-01-02, 2025-01-01",
//  // OLD: sample expiry values; expiry now derived from shelfLifeDays
//  // "2025-01-31, 2025-01-29",
//  "50, 10",
//  // "DAMAGED, GOOD",
//  // "HOLD-BIN-001, GOOD-BIN-001",
// ];


export function downloadInwardUploadTemplate() {
  const wsData = [
    TEMPLATE_HEADERS,
    INSTRUCTIONS_ROW,
    SAMPLE_ROW_1,
    SAMPLE_ROW_2,
  ];

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Header row bold (keep existing sheet logic intact)
  TEMPLATE_HEADERS.forEach((_, colIndex) => {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
    if (ws[cellAddress]) {
      ws[cellAddress].s = {
        ...(ws[cellAddress].s || {}),
        font: { ...(ws[cellAddress].s?.font || {}), bold: true },
      };
    }
  });

  // Column widths (must match TEMPLATE_HEADERS length)
  ws["!cols"] = [
   { wch: 16 }, // Invoice Number
   { wch: 14 }, // Invoice Date
   { wch: 30 }, // Company
  { wch: 30 }, // Customer SKU Code
   // { wch: 35 }, // Product Description
   { wch: 18 }, // Product Temperature
   { wch: 16 }, // Invoice Quantity
   { wch: 18 }, // Received Quantity
   { wch: 14 }, // Dock Number
   { wch: 20 }, // Dock In Time
   { wch: 20 }, // Dock Out Time
   { wch: 16 }, // Vehicle Number
   { wch: 18 }, // Vehicle Temperature
   { wch: 22 }, // Vehicle Reporting Date
   { wch: 22 }, // Vehicle Reporting Time
   { wch: 18 }, // Location
  // { wch: 10 }, // UOM
  // { wch: 18 }, // Outer UOM Quantity
   // { wch: 18 }, // Storage Type
   { wch: 24 }, // Batch Number
   { wch: 35 }, // Manufacturing Date
   { wch: 20 }, // Batch Quantity
  // { wch: 25 }, // Condition (disabled)
  // { wch: 30 }, // Bin Code (disabled)
 ];

  // Data validation for Condition column (P column now)
  const startRow = 3; // samples start from row 3 (1-indexed in Excel)
  const endRow = 5000;

  // UOM column index 16 (0-based) = Excel column Q
  ws["!dataValidation"] = [
    // {
    //   type: "list",
    //   allowBlank: 1,
    //   sqref: `Q${startRow}:Q${endRow}`,
    //   formulas: ['"PCS,KG,L,BOX,PACK,CASE,UNIT"'],
    // },
    // Storage Type list disabled — column removed from template
    // {
    //   type: "list",
    //   allowBlank: 1,
    //   sqref: `P${startRow}:P${endRow}`,
    //   formulas: ['"Frozen,Chilled,Ambient,Tropical"'],
    // },
    // {
    //   type: "list",
    //   allowBlank: 1,
    //   sqref: `V${startRow}:V${endRow}`,
    //   formulas: ['"GOOD,DAMAGED,EXPIRED"'],
    // },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME);

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
